<!-- Active Instruments Card -->
@if (sectionData) {
  <div>
    <mat-card appearance="outlined">
      <mat-card-header>
        <mat-card-title class="edit-screen-card-title"
          >1. {{ 'ccr.active' | translate }}</mat-card-title
        >
        <mat-card-subtitle>
          <p class="active-count">
            {{
              'ccr.ccrActiveCountTemplate'
                | translate
                  : {
                      creditsCount: sectionData.activeInstrumentsCount,
                      sourcesCount:
                        sectionData.activeInstrumentsInstitutionsCount,
                    }
            }}
            / Брой проверки за последните 30 дни:
            {{ sectionData.recentInquiriesInstitutionsCount }}
          </p>
        </mat-card-subtitle>
      </mat-card-header>
      <mat-card-content>
        @if (sectionData.activeInstruments || sectionData.activeMultiproducts) {
          <mat-card appearance="outlined">
            <mat-card-header>
              <mat-card-title class="edit-screen-card-title"
                >Инструменти</mat-card-title
              >
            </mat-card-header>
            <mat-card-content>
              @if (sectionData.activeInstruments) {
                <itfg-data-table
                  [data]="sectionData.activeInstruments"
                  [columns]="columnsActive"
                >
                  <ng-template itfgDataTableTemplate="flg" let-value="value">
                    <itfg-ecr-flag-display
                      [flags]="value"
                    ></itfg-ecr-flag-display>
                  </ng-template>
                  <ng-template itfgDataTableTemplate="refDat" let-value="value">
                    <span>{{ value | itfgDateFormat: dateFormat }}</span>
                  </ng-template>
                  <ng-template
                    itfgDataTableTemplate="dtMtrty"
                    let-value="value"
                  >
                    <span>{{ value | itfgDateFormat: dateFormat }}</span>
                  </ng-template>
                  <ng-template itfgDataTableTemplate="dtIncp" let-value="value">
                    <span>{{ value | itfgDateFormat: dateFormat }}</span>
                  </ng-template>
                </itfg-data-table>
              } @else {
                <span
                  flex
                  layout="row"
                  class="no-data-label"
                  [translate]="'global.noData'"
                >
                  No Data
                </span>
              }
            </mat-card-content>
          </mat-card>

          <mat-card appearance="outlined">
            <mat-card-header>
              <mat-card-title class="edit-screen-card-title"
                >Мултипродукти</mat-card-title
              >
            </mat-card-header>
            <mat-card-content>
              @if (sectionData.activeMultiproducts) {
                <itfg-data-table
                  [data]="sectionData.activeMultiproducts"
                  [columns]="columnsActiveMultiproducts"
                >
                  <ng-template itfgDataTableTemplate="refDat" let-value="value">
                    <span>{{ value | itfgDateFormat: dateFormat }}</span>
                  </ng-template>
                  <ng-template itfgDataTableTemplate="dtIncp" let-value="value">
                    <span>{{ value | itfgDateFormat: dateFormat }}</span>
                  </ng-template>
                </itfg-data-table>
              } @else {
                <span
                  flex
                  layout="row"
                  class="no-data-label"
                  [translate]="'global.noData'"
                >
                  No Data
                </span>
              }
            </mat-card-content>
          </mat-card>
        } @else {
          <span
            flex
            layout="row"
            class="no-data-label"
            [translate]="'global.noData'"
          >
            No Data
          </span>
        }
      </mat-card-content>
    </mat-card>
  </div>

  <!-- Overdue/Delinquency Card -->
  <!-- TODO: check final structure - there is no such property on 2026.01.12 -->
  <div>
    <mat-card appearance="outlined">
      <mat-card-header>
        <mat-card-title class="edit-screen-card-title"
          >2. История на просрочията</mat-card-title
        >
      </mat-card-header>
      <mat-card-content>
        @if (
          sectionData.activeInstrumentsDelinquencyHistory ||
          sectionData.inactiveInstrumentsDelinquencyHistory ||
          sectionData.legacyDelinquencyHistory
        ) {
          <mat-card appearance="outlined">
            <mat-card-title class="edit-screen-card-title">
              Активни кредити
            </mat-card-title>
            <mat-card-content>
              @if (sectionData.activeInstrumentsDelinquencyHistory) {
                <itfg-data-table
                  [data]="sectionData.activeInstrumentsDelinquencyHistory"
                  [columns]="columnsDelinquencyHistoryEcr"
                >
                  <ng-template itfgDataTableTemplate="dtIncp" let-value="value">
                    <span>{{ value | itfgDateFormat: dateFormat }}</span>
                  </ng-template>
                  <ng-template itfgDataTableTemplate="dpdCal" let-value="value">
                    <itfg-dpd-calendar [dpdCal]="value"></itfg-dpd-calendar>
                  </ng-template>
                </itfg-data-table>
              } @else {
                <span
                  flex
                  layout="row"
                  class="no-data-label"
                  [translate]="'global.noData'"
                >
                  No Data
                </span>
              }
            </mat-card-content>
          </mat-card>

          <mat-card appearance="outlined">
            <mat-card-title class="edit-screen-card-title">
              Неактивни кредити
            </mat-card-title>
            <mat-card-content>
              @if (sectionData.inactiveInstrumentsDelinquencyHistory) {
                <itfg-data-table
                  [data]="sectionData.inactiveInstrumentsDelinquencyHistory"
                  [columns]="columnsDelinquencyHistoryEcr"
                >
                  <ng-template itfgDataTableTemplate="dtIncp" let-value="value">
                    <span>{{ value | itfgDateFormat: dateFormat }}</span>
                  </ng-template>
                  <ng-template itfgDataTableTemplate="dpdCal" let-value="value">
                    <itfg-dpd-calendar [dpdCal]="value"></itfg-dpd-calendar>
                  </ng-template>
                </itfg-data-table>
              } @else {
                <span
                  flex
                  layout="row"
                  class="no-data-label"
                  [translate]="'global.noData'"
                >
                  No Data
                </span>
              }
            </mat-card-content>
          </mat-card>

          <mat-card appearance="outlined">
            <mat-card-title class="edit-screen-card-title">
              Legacy - До дата: 31.12.2025
            </mat-card-title>
            <mat-card-content>
              @if (sectionData.legacyDelinquencyHistory) {
                <itfg-data-table
                  [data]="sectionData.legacyDelinquencyHistory"
                  [columns]="columnsLegacyDelinquencyHistoryEcr"
                >
                  <ng-template itfgDataTableTemplate="dpdCal" let-value="value">
                    <itfg-dpd-calendar [dpdCal]="value"></itfg-dpd-calendar>
                  </ng-template>
                  <ng-template itfgDataTableTemplate="dtAppr" let-value="value">
                    <span>{{ value | itfgDateFormat: dateFormat }}</span>
                  </ng-template>
                </itfg-data-table>
              } @else {
                <span
                  flex
                  layout="row"
                  class="no-data-label"
                  [translate]="'global.noData'"
                >
                  No Data
                </span>
              }
            </mat-card-content>
          </mat-card>
        } @else {
          <span
            flex
            layout="row"
            class="no-data-label"
            [translate]="'global.noData'"
          >
            No Data
          </span>
        }
      </mat-card-content>
    </mat-card>
  </div>

  <!-- Related Active Instruments Card -->
  <div>
    <mat-card appearance="outlined">
      <mat-card-header>
        <mat-card-title class="edit-screen-card-title"
          >3. {{ 'ccr.relatedCredits' | translate }}</mat-card-title
        >
      </mat-card-header>
      <mat-card-content>
        @if (sectionData.relatedActiveInstruments) {
          <itfg-data-table
            [data]="sectionData.relatedActiveInstruments"
            [columns]="columnsRelatedEcr"
          >
            <ng-template itfgDataTableTemplate="refDat" let-value="value">
              <span>{{ value | itfgDateFormat: dateFormat }}</span>
            </ng-template>
          </itfg-data-table>
        } @else {
          <span
            flex
            layout="row"
            class="no-data-label"
            [translate]="'global.noData'"
          >
            No Data
          </span>
        }
      </mat-card-content>
    </mat-card>
  </div>

  <mat-card appearance="outlined">
    <mat-card-title> 4. Брой извършени проверки за лицето </mat-card-title>
    <mat-card-content>
      @if (sectionData.inquiries) {
        <itfg-data-table
          [data]="sectionData.inquiries"
          [columns]="columnsInquiryEcr"
        >
          <ng-template itfgDataTableTemplate="dtF" let-value="value">
            <span>{{ value | itfgDateFormat: dateFormat }}</span>
          </ng-template>
          <ng-template itfgDataTableTemplate="dtL" let-value="value">
            <span>{{ value | itfgDateFormat: dateFormat }}</span>
          </ng-template>
        </itfg-data-table>
      } @else {
        <span
          flex
          layout="row"
          class="no-data-label"
          [translate]="'global.noData'"
        >
          No Data
        </span>
      }
    </mat-card-content>
  </mat-card>

  <!-- <div>
  <mat-card appearance="outlined">
    <mat-card-header>
      <mat-card-title class="edit-screen-card-title">4.Предходни просрочия</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      @if (sectionData.relatedActiveInstruments) {
      <div>
        <itfg-data-table [data]="sectionData.legacyDelinquencyHistory"
                         [columns]="columnsOverdue">
          <ng-template itfgDataTableTemplate="dateFrom"
                       let-value="value">
            <span>{{ value | itfgDateFormat: dateFormat }}</span>
          </ng-template>
          <ng-template itfgDataTableTemplate="dtAppr"
                       let-value="value">
            <span>{{ value | itfgDateFormat: dateFormat }}</span>
          </ng-template>
          <ng-template itfgDataTableTemplate="dpdCal"
                       let-value="value">
            <itfg-dpd-calendar [dpdCal]="value"></itfg-dpd-calendar>
          </ng-template>
        </itfg-data-table>
      </div>
      } @else {
      <span flex
            layout="row"
            class="no-data-label"
            [translate]="'global.noData'">
        No Data
      </span>
      }
    </mat-card-content>
  </mat-card>
</div> -->

  <mat-expansion-panel hideToggle>
    <mat-expansion-panel-header>
      <mat-panel-title> Debug </mat-panel-title>
    </mat-expansion-panel-header>
    <pre>{{ sectionData | json }}</pre>
  </mat-expansion-panel>
}
